import MultAnswer from './MultAnswer';
export default MultAnswer;
